import {useEffect, useState} from "react";
import {AccountSearchDataArrInterface} from "../interface/searchInterface";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import {useMutation} from "@tanstack/react-query";
import {paginationInit} from "../../../../common/init/PaginationInit";
import {deleteAccountApi} from "../../../../../api/account/AccountApi";
import {useModal} from "../../../../../hooks";
import {PaginationMain} from "../../../../../components/common/pagination/PaginationMain";
import AuthorityChecker from "../../../../../components/common/authorityGuard/AuthorityChecker";

export const AccountTable = ({
                                 searchData,
                                 dataCount,
                                 searchParam,
                                 setSearchParam,
                                 setRefresh
                             }: AccountSearchDataArrInterface) => {
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();
    const [allChecked, setAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState<Set<number>>(new Set());
    const [currentPage, setCurrentPage] = useState(paginationInit);

    const handleAllCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setAllChecked(isChecked);
        setCheckedItems(new Set(isChecked ? searchData.map((item: any) => item.userId) : []));
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, userId: number) => {
        const newCheckedItems = new Set(checkedItems);
        e.target.checked ? newCheckedItems.add(userId) : newCheckedItems.delete(userId);
        setCheckedItems(newCheckedItems);
        setAllChecked(newCheckedItems.size === searchData.length);
    };

    const deleteCallback = () => {
        const data = Array.from(checkedItems).map(userId => ({userId}));
        deleteAccountApiMutate.mutate(data);
    }

    const deleteItems = () => {
        if (checkedItems.size > 0) {
            handleModal({isOpen: true, contents: "선택된 계정을 삭제하시겠습니까?", type: "confirm", callback: deleteCallback})
        } else {
            handleModal({isOpen: true, contents: "삭제할 계정을 선택해주세요.", type: "alert"})
        }
    };

    const deleteAccountApiMutate = useMutation({
        mutationFn: (data: any) => deleteAccountApi(data),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setRefresh(true)
                setCheckedItems(new Set())
                handleModal({isOpen: true, contents: "계정이 삭제되었습니다.", type: "alert"})
            } else {
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(() => {
        setSearchParam(prev => ({...prev, pageNo: currentPage.page}));
    }, [currentPage]);

    return (
        <>
            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">계정 목록(<span>{dataCount}</span>건)</h6>
                    <div className="table_toolbar">
                        <AuthorityChecker authorityNames={['accountWriteYn']}>
                            <button className="btn btn-outline-dark ms-40px" onClick={deleteItems}>
                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon_cross.png`} alt=""/>선택삭제
                            </button>
                            <button className="btn btn-primary"
                                    onClick={() => goToNavigation("manage/account/create", "", false)}>
                                계정 생성
                            </button>
                        </AuthorityChecker>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <AuthorityChecker authorityNames={['accountWriteYn']}>
                                <th style={{width: "4.4%"}}>
                                    <input
                                        type="checkbox"
                                        checked={allChecked}
                                        onChange={handleAllCheckboxChange}
                                    />
                                </th>
                            </AuthorityChecker>
                            <th>ID</th>
                            <th>이름</th>
                            <th>직함</th>
                            <th>회사명</th>
                            <th>부서</th>
                            <th>팀</th>
                            <th>구분</th>
                            <th>조직</th>
                            <th>역할</th>
                        </tr>
                        </thead>
                        <tbody>
                        {searchData && searchData.length > 0 ? (
                            searchData.map(item => (
                                <tr key={item.userId}
                                    className="clickable"
                                    onClick={() => goToNavigation(`manage/account/detail/${item.userId}`, "", false)}>
                                    <AuthorityChecker authorityNames={['accountWriteYn']}>
                                        <td className="text-center" style={{width: "4.4%"}}
                                            onClick={e => e.stopPropagation()}>
                                            <input
                                                type="checkbox"
                                                checked={checkedItems.has(item.userId)}
                                                onChange={e => handleCheckboxChange(e, item.userId)}
                                            />
                                        </td>
                                    </AuthorityChecker>
                                    <td>{item.loginId}</td>
                                    <td className="text-center">{item.userName}</td>
                                    <td className="text-center" style={{width: "100px"}}>{item.title || "-"}</td>
                                    <td>{item.companyName}</td>
                                    <td>{item.departmentName}</td>
                                    <td>{item.teamName}</td>
                                    <td className="text-center" style={{width: "100px"}}>{item.dutyGroupTypeName}</td>
                                    <td className="text-center" style={{width: "100px"}}>{item.orgName}</td>
                                    <td className="text-center" style={{width: "100px"}}>{item.roleName}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={11} className="text-center">데이터가 없습니다.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationMain totalCount={dataCount ?? 0}/>
            </div>
        </>
    );
};